import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AppleCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // 获取URL参数
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const idToken = urlParams.get('id_token');
    const state = urlParams.get('state');
    const error = urlParams.get('error');

    console.log('🍎 Apple Callback Page - URL Params:', {
      code,
      idToken,
      state,
      error
    });

    if (error) {
      console.error('🍎 Apple ID Error:', error);
      // 重定向回主页并显示错误
      navigate('/?apple_error=' + error);
      return;
    }

    if (code && idToken && state === 'apple_login_state') {
      console.log('🍎 Apple ID Success - redirecting to main page');
      // 重定向回主页，携带成功参数
      navigate('/?apple_success=true&code=' + encodeURIComponent(code) + '&id_token=' + encodeURIComponent(idToken));
    } else {
      console.log('🍎 Apple ID Callback - no valid parameters');
      // 重定向回主页
      navigate('/');
    }
  }, [navigate]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontSize: '18px'
    }}>
      Processing Apple ID login...
    </div>
  );
};

export default AppleCallback;
